import {
  LENGTH_FORMATS_BY_UNIT_SYSTEM,
  LengthFormat,
  UnitSystem,
} from '@ritabygglov/core';
import { useIntl } from 'react-intl';

const LABEL_KEYS: Record<LengthFormat, string> = {
  meters: 'settings.lengthFormatMeters',
  millimeters: 'settings.lengthFormatMillimeters',
  'feet-inches': 'settings.lengthFormatFeetInches',
  'decimal-feet': 'settings.lengthFormatDecimalFeet',
};

/** <option>s for the length-format <select>, limited to the notations the
 * given unit system can render. */
export const LengthFormatOptions = ({
  unitSystem,
}: {
  unitSystem: UnitSystem;
}) => {
  const intl = useIntl();

  return (
    <>
      {LENGTH_FORMATS_BY_UNIT_SYSTEM[unitSystem].map((lengthFormat) => (
        <option value={lengthFormat} key={lengthFormat}>
          {intl.formatMessage({ id: LABEL_KEYS[lengthFormat] })}
        </option>
      ))}
    </>
  );
};
